module.exports = __webpack_public_path__ + "de5d1227e0f1b82765d3cbe826173f19.png";